import classNames from 'classnames'
import React, { useRef } from 'react'
import SVGIcon from '../svg/SVGIcon'
import { usePagination } from '../utils/pagination'
import { useScrollableList } from '../utils/scroll'
import ScrollList from './ScrollList'
import s from './ScrollListWithPagination.less'
import arrowLeft from './assets/arrow-left.svg'
import arrowRight from './assets/arrow-right.svg'

const Arrow = ({ onClick, direction, arrowClassName, arrowLeftClassName, arrowRightClassName }) => (
  <div
    className={classNames(direction === 'right' ? arrowRightClassName : arrowLeftClassName, arrowClassName)}
    onClick={onClick}
  >
    <SVGIcon url={direction === 'right' ? arrowRight : arrowLeft} className={s.arrowPicto} />
  </div>
)

const STEP_SIZE = 4

const ScrollListWithPagination = ({
  data,
  render,
  listClassName,
  listItemClassName,
  selectedItem,
  arrowClassName,
  arrowLeftClassName,
  arrowRightClassName
}) => {
  const scrollableContainerRef = useRef()
  const { page: targetScrollElementIndex, goNext, hasNext, hasPrev, goPrev } = usePagination(data.length, STEP_SIZE)

  const listElementsRefsToScroll = useScrollableList(data.length, scrollableContainerRef, targetScrollElementIndex)

  return (
    <div className={s.scrollListWithPagination}>
      {hasPrev() && (
        <Arrow
          direction="left"
          onClick={goPrev}
          arrowClassName={arrowClassName}
          arrowLeftClassName={arrowLeftClassName}
          arrowRightClassName={arrowRightClassName}
        />
      )}
      <ScrollList
        listRef={scrollableContainerRef}
        listItemsRefs={listElementsRefsToScroll}
        {...{
          data,
          render,
          listClassName,
          listItemClassName,
          selectedItem
        }}
      />
      {hasNext() && (
        <Arrow
          direction="right"
          onClick={goNext}
          arrowClassName={arrowClassName}
          arrowLeftClassName={arrowLeftClassName}
          arrowRightClassName={arrowRightClassName}
        />
      )}
    </div>
  )
}

ScrollListWithPagination.propTypes = {
  ...ScrollList.propTypes
}

export default ScrollListWithPagination
